module.exports = __webpack_public_path__ + "static/media/RR.441f0558.jpg";